import $ from 'jquery';
import { $win } from '../utils/globals';
import { setCookie } from "../utils/cookies";

$win.on('load', function() {
    $('.js-plan-submit-btn[disabled]').removeAttr('disabled');
    $('.js-roaming-plan-submit-btn[disabled]').removeAttr('disabled');
})


const  plansSubmitButton = () => {
    
    $('.js-plan-submit-btn').on('click', function(e) {
        e.preventDefault();
    
        localStorage.removeItem('formValues');
        localStorage.removeItem('formFragmentValues');
    
        const plan_id = $(this).closest('form').find('input[name="plan_id"]').val();
    
        setCookie('plan_id', plan_id, 1);
    
        window.location.replace('/steps');
    }) 

    $('.js-roaming-plan-submit-btn').on('click', function(e) {
        e.preventDefault();
    
        localStorage.removeItem('formValues');
        localStorage.removeItem('formFragmentValues');
    
        const plan_id = $(this).closest('form').find('input[name="plan_id"]').val();
    
        setCookie('roaming_plan_id', plan_id, 1);
    
        window.location.replace('/roaming-steps');
    }) 
}

export default plansSubmitButton;